// extracted by mini-css-extract-plugin
export default {"boxsize":"200px","halfboxsize":"100px","neghalfboxsize":"-100px","cornflowerBlue":"#26293f"};